import Vue from 'vue';


export const isServer = Vue.prototype.$isServer;

export function isDef(value) {
  return value !== undefined && value !== null;
}

export function mount(Component, data={}) {
  const instance = new Vue({
    el: document.createElement('div'),
    props: Component.props,
    render(h) {
      return h(Component, {
		props: this.$props,
		...data
	  });
    }
  });

  document.body.appendChild(instance.$el);

  return instance;
}

export function isObj(x) {
  const type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

export function isInDocument(element) {
  return document.body.contains(element);
}

export function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}


/**
 * 动态创建加载js
 * @param url
 * @returns {Promise<any>}
 */
export function loadJs( url ) {
	return new Promise((resolve, reject) => {
		try {
			let scripts = document.getElementsByTagName('script');
			for (let i = 0; i < scripts.length; i++) {
				const element = scripts[i];
				if ( element.src === url ) {
					resolve();
					return;
				}
			}
			let script = document.createElement('script');
			script.type = "text/javascript";
			if (script.readyState) {
				script.onreadystatechange = function () {
				if (script.readyState == "loaded" || script.readyState == "complete") {
					script.onreadystatechange = null;
					resolve();
				}
				}
			} else {
				script.onload = function () {
					resolve();
				}
			}
			script.src = url;
			document.head.appendChild(script);
		} catch (e) {
			reject(e)
		}
	})
}